import { render, staticRenderFns } from "./comment_slice.vue?vue&type=template&id=5ba0f14c&scoped=true&"
import script from "./comment_slice.vue?vue&type=script&lang=js&"
export * from "./comment_slice.vue?vue&type=script&lang=js&"
import style0 from "./comment_slice.vue?vue&type=style&index=0&id=5ba0f14c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba0f14c",
  null
  
)

export default component.exports